<template>
  <v-list two-line :class="itemIndex = 0">
    <v-list-tile v-for="item in items" :key="item.product_id" avatar class="itemDivider">
      <v-list-tile-avatar>
        <play-btn
          :itemIndex="itemIndex"
          :itemTitle="item.name"
          :itemArtist="item.artist_name"
          :itemSrc="item.mp3"
          :itemProductId="item.product_id"
          :musicPlayerType="'favorite'"
        />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
        <v-list-tile-sub-title @click="moveDetail(item.artist_id)" class="hover-type01">{{ item.artist_name }}</v-list-tile-sub-title>
      </v-list-tile-content>
      <v-spacer></v-spacer>
      <lyrics
        :title="item.name"
        :artist="item.artist_name"
        :lyrics="item.lyrics"
        :introduction="item.introduction"
      />
      <more-btn
      :class="itemIndex = itemIndex + 1"
      :addIsumBtn="false"
      :addCommentBtn="false"
      :addMusicBtn="false"
      :addListBtn="true"
      :addFavoriteBtn="false"
      :deleteListBtn="true"
      :productId="item.product_id"
     />
    </v-list-tile>
  </v-list>
</template>

<script>
import FavoriteService from '@/components/services/FavoriteService.vue'
import MoreBtn from '@/components/MoreBtn.vue'
import Lyrics from '@/components/Lyrics.vue'
import PlayBtn from '@/components/PlayBtn.vue'
export default {
  components: {
    MoreBtn,
    Lyrics,
    PlayBtn
  },
  data () {
    return {
      items: {}
    }
  },
  props: {
    source: String
  },
  created () {
    var transactionId = this.$store.state.transactionId
    this.getFavoriteTunes(transactionId)
  },
  methods: {
    /**
     * お気に入り楽曲を取得
     * @param transactionId
     **/
    getFavoriteTunes (transactionId) {
      this.logging('methods: getFavoriteTunes')
      FavoriteService.findAllFavoriteTune(transactionId, (response) => {
        this.items = response
        this.$store.dispatch('favoriteListModuleSetPlayList', this.items)
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * アーティスト詳細ボタンをクリックしたときの処理
     **/
    moveDetail (artistId) {
      this.$router.push({path: '/home/artist/detail/' + artistId})
    },
    async clickAvatar () {
      await this.$store.commit('musicPlayerModuleSetPlayList', 'favorite')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FavoriteList.vue